import { EpisodeTextImportCommandKey } from './episodeTextImportCommandTypes';
import { EpisodeTextEntityType } from './episodeTextImportTypes';

export type EpisodeTextImportCrossCommandType = {
  commands: Record<EpisodeTextImportCommandKey, EpisodeTextImportCommandKey[]>,
  entityType: Record<EpisodeTextImportCommandKey, EpisodeTextEntityType[]>,
}

const crossCommandKeysStepsForExpression = [
  EpisodeTextImportCommandKey.StepReact,
  EpisodeTextImportCommandKey.StepThink,
  EpisodeTextImportCommandKey.StepChoice,
];

const crossEntityTypesForExpression = [
  EpisodeTextEntityType.Choice,
  EpisodeTextEntityType.Dialogue,
  EpisodeTextEntityType.Reaction,
  EpisodeTextEntityType.Thinking,
];

export const crossCommandKeysExpressionsForStep = [
  EpisodeTextImportCommandKey.ExpressionAnxious,
  EpisodeTextImportCommandKey.ExpressionBlush,
  EpisodeTextImportCommandKey.ExpressionBored,
  EpisodeTextImportCommandKey.ExpressionDelight,
  EpisodeTextImportCommandKey.ExpressionDisgust,
  EpisodeTextImportCommandKey.ExpressionFlirting,
  EpisodeTextImportCommandKey.ExpressionHappy,
  EpisodeTextImportCommandKey.ExpressionNeutral,
  EpisodeTextImportCommandKey.ExpressionRage,
  EpisodeTextImportCommandKey.ExpressionSad,
  EpisodeTextImportCommandKey.ExpressionScared,
  EpisodeTextImportCommandKey.ExpressionShock,
  EpisodeTextImportCommandKey.ExpressionSmile,
  EpisodeTextImportCommandKey.ExpressionThinking,
  EpisodeTextImportCommandKey.ExpressionWicked,
];

export const EpisodeTextImportCrossCommands: EpisodeTextImportCrossCommandType = {
  commands: {
    [EpisodeTextImportCommandKey.Background]: [],
    [EpisodeTextImportCommandKey.Goto]: [EpisodeTextImportCommandKey.PremiumAnswer, EpisodeTextImportCommandKey.BonusContent, EpisodeTextImportCommandKey.StepReq],
    [EpisodeTextImportCommandKey.Location]: [],
    [EpisodeTextImportCommandKey.StepChoice]: [...crossCommandKeysExpressionsForStep],
    [EpisodeTextImportCommandKey.StepChat]: [],
    [EpisodeTextImportCommandKey.StepThink]: [...crossCommandKeysExpressionsForStep, EpisodeTextImportCommandKey.StepReact],
    [EpisodeTextImportCommandKey.StepReact]: [...crossCommandKeysExpressionsForStep, EpisodeTextImportCommandKey.StepThink],
    [EpisodeTextImportCommandKey.StepRemember]: [],
    [EpisodeTextImportCommandKey.StepRandom]: [],
    [EpisodeTextImportCommandKey.StepCheck]: [],
    [EpisodeTextImportCommandKey.ExpressionAnxious]: [...crossCommandKeysStepsForExpression],
    [EpisodeTextImportCommandKey.ExpressionBlush]: [...crossCommandKeysStepsForExpression],
    [EpisodeTextImportCommandKey.ExpressionBored]: [...crossCommandKeysStepsForExpression],
    [EpisodeTextImportCommandKey.ExpressionDelight]: [...crossCommandKeysStepsForExpression],
    [EpisodeTextImportCommandKey.ExpressionDisgust]: [...crossCommandKeysStepsForExpression],
    [EpisodeTextImportCommandKey.ExpressionFlirting]: [...crossCommandKeysStepsForExpression],
    [EpisodeTextImportCommandKey.ExpressionHappy]: [...crossCommandKeysStepsForExpression],
    [EpisodeTextImportCommandKey.ExpressionNeutral]: [...crossCommandKeysStepsForExpression],
    [EpisodeTextImportCommandKey.ExpressionRage]: [...crossCommandKeysStepsForExpression],
    [EpisodeTextImportCommandKey.ExpressionSad]: [...crossCommandKeysStepsForExpression],
    [EpisodeTextImportCommandKey.ExpressionScared]: [...crossCommandKeysStepsForExpression],
    [EpisodeTextImportCommandKey.ExpressionShock]: [...crossCommandKeysStepsForExpression],
    [EpisodeTextImportCommandKey.ExpressionSmile]: [...crossCommandKeysStepsForExpression],
    [EpisodeTextImportCommandKey.ExpressionThinking]: [...crossCommandKeysStepsForExpression],
    [EpisodeTextImportCommandKey.ExpressionWicked]: [...crossCommandKeysStepsForExpression],
    [EpisodeTextImportCommandKey.PremiumAnswer]: [EpisodeTextImportCommandKey.Goto, EpisodeTextImportCommandKey.BonusContent, EpisodeTextImportCommandKey.StepReq],
    [EpisodeTextImportCommandKey.BonusContent]: [EpisodeTextImportCommandKey.Goto, EpisodeTextImportCommandKey.PremiumAnswer, EpisodeTextImportCommandKey.StepReq],
    [EpisodeTextImportCommandKey.StepEnding]: [],
    [EpisodeTextImportCommandKey.StepReq]: [EpisodeTextImportCommandKey.Goto, EpisodeTextImportCommandKey.PremiumAnswer, EpisodeTextImportCommandKey.BonusContent],
    [EpisodeTextImportCommandKey.StepVideo]: [],
    [EpisodeTextImportCommandKey.StepAchieve]: [],
  },
  entityType: {
    [EpisodeTextImportCommandKey.Background]: [EpisodeTextEntityType.Dialogue, EpisodeTextEntityType.Narration, EpisodeTextEntityType.Thinking, EpisodeTextEntityType.Reaction, EpisodeTextEntityType.Choice, EpisodeTextEntityType.Chat, EpisodeTextEntityType.Video, EpisodeTextEntityType.Ending, EpisodeTextEntityType.Remember, EpisodeTextEntityType.Random, EpisodeTextEntityType.Check, EpisodeTextEntityType.Achieve],
    [EpisodeTextImportCommandKey.Goto]: [EpisodeTextEntityType.Answer, EpisodeTextEntityType.GotoFromNode, EpisodeTextEntityType.CheckCondition],
    [EpisodeTextImportCommandKey.StepChoice]: [EpisodeTextEntityType.Choice],
    [EpisodeTextImportCommandKey.Location]: [EpisodeTextEntityType.Node],
    [EpisodeTextImportCommandKey.StepChat]: [EpisodeTextEntityType.Chat],
    [EpisodeTextImportCommandKey.StepThink]: [EpisodeTextEntityType.Thinking, EpisodeTextEntityType.Reaction],
    [EpisodeTextImportCommandKey.StepReact]: [EpisodeTextEntityType.Reaction, EpisodeTextEntityType.Thinking],
    [EpisodeTextImportCommandKey.StepRemember]: [EpisodeTextEntityType.Remember],
    [EpisodeTextImportCommandKey.StepRandom]: [EpisodeTextEntityType.Random],
    [EpisodeTextImportCommandKey.StepCheck]: [EpisodeTextEntityType.Check, EpisodeTextEntityType.CheckConditionList],
    [EpisodeTextImportCommandKey.ExpressionAnxious]: crossEntityTypesForExpression,
    [EpisodeTextImportCommandKey.ExpressionBlush]: crossEntityTypesForExpression,
    [EpisodeTextImportCommandKey.ExpressionBored]: crossEntityTypesForExpression,
    [EpisodeTextImportCommandKey.ExpressionDelight]: crossEntityTypesForExpression,
    [EpisodeTextImportCommandKey.ExpressionDisgust]: crossEntityTypesForExpression,
    [EpisodeTextImportCommandKey.ExpressionFlirting]: crossEntityTypesForExpression,
    [EpisodeTextImportCommandKey.ExpressionHappy]: crossEntityTypesForExpression,
    [EpisodeTextImportCommandKey.ExpressionNeutral]: crossEntityTypesForExpression,
    [EpisodeTextImportCommandKey.ExpressionRage]: crossEntityTypesForExpression,
    [EpisodeTextImportCommandKey.ExpressionSad]: crossEntityTypesForExpression,
    [EpisodeTextImportCommandKey.ExpressionScared]: crossEntityTypesForExpression,
    [EpisodeTextImportCommandKey.ExpressionShock]: crossEntityTypesForExpression,
    [EpisodeTextImportCommandKey.ExpressionSmile]: crossEntityTypesForExpression,
    [EpisodeTextImportCommandKey.ExpressionThinking]: crossEntityTypesForExpression,
    [EpisodeTextImportCommandKey.ExpressionWicked]: crossEntityTypesForExpression,
    [EpisodeTextImportCommandKey.PremiumAnswer]: [EpisodeTextEntityType.Answer],
    [EpisodeTextImportCommandKey.BonusContent]: [EpisodeTextEntityType.Answer],
    [EpisodeTextImportCommandKey.StepEnding]: [EpisodeTextEntityType.Ending],
    [EpisodeTextImportCommandKey.StepReq]: [EpisodeTextEntityType.Answer],
    [EpisodeTextImportCommandKey.StepVideo]: [EpisodeTextEntityType.Video],
    [EpisodeTextImportCommandKey.StepAchieve]: [EpisodeTextEntityType.Achieve],
  },
};
